<template>
  <div class="modal-body alcoholandhealth">
    <h1>POSIBLES EFECTOS DEL ALCOHOL</h1>
    <div class="divider"></div>
    El consumo de alcohol es una decisión individual y afecta a las personas de distintas 
    maneras. Algunos estudios han indicado una posible relación entre el consumo de alcohol 
    y un mayor riesgo de padecer ciertos problemas de salud. El consumo de grandes cantidades 
    de manera regular se ha vinculado a diversos padecimientos, como enfermedades hepáticas, 
    enfermedades cardiovasculares, dependencia física y mayor riesgo de ciertos tipos de 
    cáncer. El consumo compulsivo de alcohol, es decir, consumir grandes cantidades de alcohol 
    en un período breve, es peligroso y puede causar graves problemas de salud. En algunas 
    personas, el consumo moderado de alcohol puede incrementar varios riesgos de salud y 
    ciertos tipos de cáncer, como el de mama. Además del ritmo de consumo, otros factores 
    que pueden influir en el nivel de riesgo son la cantidad y frecuencia de consumo, la 
    edad, el sexo, la genética y el estilo de vida. Por lo tanto, debes consultar con tu 
    proveedor de servicios de salud o profesional médico para determinar si el consumo 
    moderado de alcohol es conveniente conforme a tu situación personal de salud.
    <br>
    <br />
    Para mayor información visita:
    <a target="_blank" href="https://www.moderationmatters.com/mx">https://www.moderationmatters.com/mx</a>
    <br>
    <br>
  </div>
</template>

<script>
export default {
  name: "AlcoholAndHealth",
  props: {
    name: {
      type: String,
      default: "cuamoc.com.mx",
    },
  },
};
</script>
<style lang="scss" >

.alcoholandhealth {
  font-family: 'DunbarTall-Light' !important;
  font-size: 0.9rem !important;
  margin-right: 12.2pt !important;
  text-align: justify;
  h3, p{
    margin: 0;
    margin-bottom: 1rem
  }
  h1 {
    font-size: 1.3rem !important;
  }
  a {
    font-size: 0.9rem !important;
  }
  .divider {
    border-block: 2.5px rgb(210, 113, 97) solid;
    width: 100%;
    margin-bottom: 1em;
    margin-top: 0px;
  }
  *{
font-family: 'DunbarTall-Light' !important;
  font-size: 0.9rem !important;
  }
}
</style>
